// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"390":"c14970b7","453":"80518f88"}[chunkId] + ".chunk.js";
};